export default "__VITE_ASSET__DQvP437i__"